import { render, staticRenderFns } from "./SMSAlerts.html?vue&type=template&id=74a5afa6&scoped=true&external"
import script from "./SMSAlerts.js?vue&type=script&lang=js&external"
export * from "./SMSAlerts.js?vue&type=script&lang=js&external"
import style0 from "./SMSAlerts.scss?vue&type=style&index=0&id=74a5afa6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a5afa6",
  null
  
)

export default component.exports